/* global jQuery */

// expand / collapse agenda rows
(function ($) {
	"use strict";

	var readMore = "Read <span class=\"nowrap\">more<img class=\"link-arrow\" src=\"https://ik.imagekit.io/qualys/image/icon/link-arrow.svg\" width=\"7\" height=\"10\"></span>";
	var readLess = "Read <span class=\"nowrap\">less<img class=\"link-arrow\" src=\"https://ik.imagekit.io/qualys/image/icon/link-arrow.svg\" width=\"7\" height=\"10\"></span>";

	$(".js-read-more").on("click", function(event){
		var video_abstract = $(event.currentTarget).parents(".q-grid__column").find(".q-ignite__video-description");
		video_abstract.toggleClass("hidden");
		if(video_abstract.hasClass("hidden")){
			$(event.currentTarget).html(readMore);
		}
		else {
			$(event.currentTarget).html(readLess);
		}
	});

}(jQuery));
